import { render, staticRenderFns } from "./InvoiceTemplate.vue?vue&type=template&id=858298f4&scoped=true&"
import script from "./InvoiceTemplate.vue?vue&type=script&lang=js&"
export * from "./InvoiceTemplate.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceTemplate.vue?vue&type=style&index=0&id=858298f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858298f4",
  null
  
)

export default component.exports